import { render, staticRenderFns } from "./GoalForm.vue?vue&type=template&id=4ea0a9d0&scoped=true"
import script from "./GoalForm.vue?vue&type=script&lang=js"
export * from "./GoalForm.vue?vue&type=script&lang=js"
import style0 from "./GoalForm.vue?vue&type=style&index=0&id=4ea0a9d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea0a9d0",
  null
  
)

export default component.exports